import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import thunkMiddleware from "redux-thunk";

import { dashboardApi } from "../store/api/dashboardApi";
import { authApi } from "../store/api/authApi";
import { userApi } from "../store/api/userApi";
import { recordingApi } from "../store/api/recordingApi";
import { clientApi } from "../store/api/clientApi";
import { clientSchemaApi } from "../store/api/clientSchemaApi";
import { adminApi } from "../store/api/adminApi";
import { externalApi } from "../store/api/externalApi";
import { reportApi } from "../store/api/reportApi";
import { reportsApi } from "../store/api/reportsApi";

export function configureStore(initialState) {
  const allMiddlewares = [
    thunkMiddleware,
    dashboardApi.middleware,
    authApi.middleware,
    userApi.middleware,
    recordingApi.middleware,
    clientApi.middleware,
    clientSchemaApi.middleware,
    adminApi.middleware,
    externalApi.middleware,
    reportApi.middleware,
    reportsApi.middleware,
  ];

  const store = createStore(
    reducers,
    initialState,
    compose(applyMiddleware(...allMiddlewares)),
  );

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const nextRootReducer = require("./reducers");
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
